{
  "draft": {
    "restoreTitle": "Recuperar rascunho de {{date}}?",
    "restoreHint": "Este rascunho ainda não foi enviado. Anexos e fotos não são guardados nele: selecione-os de novo, se precisar.",
    "restore": "Recuperar",
    "discard": "Descartar",
    "saveFailed": "Não foi possível salvar o rascunho neste dispositivo.",
    "saveFailedHint": "O que você digitou continua na tela, mas ainda não foi enviado."
  },
  "update": {
    "available": "Há uma atualização disponível. Você pode atualizar assim que terminar.",
    "hintForm": "Vamos tentar salvar seu rascunho neste dispositivo antes. Anexos ainda não enviados precisarão ser selecionados de novo.",
    "hintUpload": "Há um envio em andamento. Se atualizar agora, ele será interrompido e o arquivo precisará ser selecionado de novo.",
    "manual": "Há uma atualização disponível. A atualização automática não funcionou; toque em Atualizar para tentar de novo.",
    "now": "Atualizar agora",
    "manualButton": "Atualizar",
    "applying": "Atualizando…",
    "saveFailedBody": "Não foi possível salvar o rascunho neste dispositivo. Se atualizar agora, o que você digitou será perdido.",
    "anyway": "Atualizar mesmo assim",
    "keepEditing": "Continuar editando",
    "chunkFailed": "Não foi possível carregar esta parte do app. Verifique sua conexão e tente de novo.",
    "retry": "Tentar de novo"
  },
  "install": {
    "title": "Instalar o Lumora",
    "intro": "Você pode adicionar o Lumora à tela inicial para abri-lo como um app. Ele funciona principalmente online: não há uso completo sem internet.",
    "installed": "Você já está usando o Lumora como app instalado.",
    "iphone": {
      "title": "iPhone (Safari)",
      "step1": "Abra o Lumora no Safari.",
      "step2": "Toque em Compartilhar.",
      "step3": "Escolha Adicionar à Tela de Início.",
      "step4": "Toque em Adicionar."
    },
    "android": {
      "title": "Android (Chrome)",
      "step1": "Abra o Lumora no Chrome.",
      "step2": "Abra o menu (três pontos).",
      "step3": "Toque em Instalar app ou Adicionar à tela inicial.",
      "step4": "Confirme."
    },
    "desktop": {
      "title": "Computador (Chrome ou Edge)",
      "step1": "Abra o Lumora no navegador.",
      "step2": "Clique no ícone de instalar na barra de endereços ou abra o menu e escolha Instalar Lumora.",
      "step3": "Confirme."
    },
    "note": "Quando houver uma versão nova, o Lumora avisa e atualiza quando for seguro. Se o app instalado parecer desatualizado, feche-o e abra de novo."
  },
  "forms": {
    "warrantyReminderHint": "Com isso marcado, o lembrete 30 dias antes do fim da garantia informada fica ativo. Só avisamos com base na data que você declarou."
  }
}
